import axios from 'axios';
import { arrayToObject } from './helpers';
import { API_ROOT, S3_BUCKET_REGION, IDENTITY_POOL_ID } from './constants';
import { store } from "./store";
import AWS from 'aws-sdk';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faClock, faCalendar, faExclamationCircle, faClipboardCheck, faCheck, faSearch,
  faPlus, faEye, faPlusSquare, faTimes, faEdit, faList, faGripVertical, faSearchPlus,
  faUpload, faChevronDown, faChevronRight, faChartLine, faLayerGroup, faClipboardList, faFolderOpen, faShareAlt, faLifeRing, faDownload} from '@fortawesome/free-solid-svg-icons'
import { faArrowAltCircleRight, faCheckSquare, faSquare, faPlayCircle } from '@fortawesome/free-regular-svg-icons';
export const configureFontAwesomeIcons = () => {
  library.add(faClock, faArrowAltCircleRight,
  faCalendar, faExclamationCircle, faPlayCircle,
  faClipboardCheck, faCheck, faSquare, faCheckSquare,
  faSearch, faPlus, faEye, faPlusSquare, faTimes, faEdit,
  faDownload,
  faList, faGripVertical, faSearchPlus, faUpload, faChevronDown, faChevronRight, faChartLine, faLayerGroup, faClipboardList, faFolderOpen, faShareAlt, faLifeRing)
}


export const configureAxios = () => {
  //CONFIGURE AXIOS HERE

  axios.defaults.baseURL = API_ROOT;
  axios.defaults.headers.common['Authorization'] = null;
  axios.defaults.headers.patch['Content-Type'] = 'application/json';
  axios.defaults.transformResponse = [
    (data) => {
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
          if (Array.isArray(data)) {
            data = arrayToObject(data);
          }
        } catch (e) { /* Ignore */
          console.warn(e)
        }
      }
      return data;
    }
  ]
  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
      const status = error.response ? error.response.status : null;
      if (status === 401) {
          const state = store.getState();
          const { isAuthenticated } = state.currentUser;
          if (isAuthenticated)  {
            localStorage.clear();
            window.location.reload();
          }
      }
      return Promise.reject(error);
  });
}



export const configureAws = () => {
  AWS.config.update({
    region: S3_BUCKET_REGION,
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: IDENTITY_POOL_ID
    })
  });
}



// WEBPACK FOOTER //
// ./src/config.js